class AppAjsController {
    /*@ngInject*/
    constructor($rootScope, $timeout, $state, authService, StorageService, utilityService, MESSAGECONSTANTS, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$state = $state;
        this.authService = authService;
        this.StorageService = StorageService;
        this.utilityService = utilityService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        this.listenToToggleHeaderDisplay();
        this.cleanUpLogoutMeeting = this.$rootScope.$on("logoutFromMeeting", () => {
            this.userActive = false;
            this.showHeaderNav = true;
            this.$timeout(() => {
                this._logoutAndRedirectUser(true);
            }, 1000);
        });
    }
    listenToToggleHeaderDisplay() {
        this.utilityService.receiveToggleHeaderNavDisplay().then(null, null, (display) => {
            this.showHeaderNav = display;
        });
    }
    _logoutAndRedirectUser(redirectFlag) {
        var rememberMeStatus = angular.copy(this.StorageService.getCookie('rememberme'));
        let userDetails = angular.copy(this.StorageService.get('userDetails'));
        this.StorageService.resetBrowserStorage();
        if (angular.isDefined(rememberMeStatus) && (rememberMeStatus !== null) && (rememberMeStatus === true)) {
            if (angular.isDefined(userDetails) && (userDetails !== null)) {
                this.StorageService.setCookie('logoutemail', userDetails.emailId);
            }
        }
        this.authService.logout((data) => {
            this.StorageService.removeCookie('connect.sid');
            this.StorageService.remove('companyDetails');
            this.StorageService.remove('SelectedHostCompany');
            this.StorageService.remove('userDetails');
            this.$state.go('exitMeeting', null, { reload: true });
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    $onDestroy() {
        if (this.cleanUpLogoutMeeting) {
            this.cleanUpLogoutMeeting();
        }
    }
}
AppAjsController.$inject = ['$rootScope', '$timeout', '$state', 'authService', 'StorageService', 'utilityService', 'MESSAGECONSTANTS', 'alertsAndNotificationsService'];
// const html = require('!raw-loader!./app.component.html');
// @ts-ignore
import * as TEMPLATE from 'raw-loader!./app.component.ajs.html';
export const AppAjsComponent = {
    selector: 'appAjs',
    component: {
        bindings: {
            userActive: '=',
            disableScreen: '=',
            appLoaded: '=',
            showHeaderNav: '='
        },
        controller: AppAjsController,
        // templateUrl: "./app.component.ajs.html"
        template: TEMPLATE.default
        // app.ajs.html'
    }
};
//# sourceMappingURL=app.component.ajs.js.map